import { useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export const InitialSelectionPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.update(() => {
      const editorElement = editor.getRootElement();
      if (editorElement) {
        editorElement.focus({ preventScroll: true });
      }
    });
  }, [editor]);

  return null;
};
